import React from 'react';
import { Result, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';

const Unauthorized: React.FC = () => {
  const history = useHistory();
  const { user } = useAuth();
  const { t } = useTranslation();

  // Détermine où rediriger l'utilisateur en fonction de ses rôles
  const handleBackHome = () => {
    if (user && user.authorities) {
      if (user.authorities.includes('ROLE_ADMIN')) {
        history.push('/admin/dashboard');
      } else if (user.authorities.includes('ROLE_AGENCY')) {
        history.push('/agency/dashboard');
      } else if (user.authorities.includes('ROLE_SUBSCRIBER')) {
        history.push('/subscriber/dashboard');
      } else {
        history.push('/login');
      }
    } else {
      history.push('/login');
    }
  };

  return (
    <Result
      status="403"
      title={t('errors.unauthorizedTitle')}
      subTitle={t('errors.unauthorizedSubTitle')}
      extra={
        <Button type="primary" onClick={handleBackHome}>
          {t('errors.backToHome')}
        </Button>
      }
    />
  );
};

export default Unauthorized;
